import { render, staticRenderFns } from "./modal-audit.vue?vue&type=template&id=2ddb7fe9&"
import script from "./modal-audit.vue?vue&type=script&lang=js&"
export * from "./modal-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports